/**
 * @license GPL-3.0-only
 *
 * @author Mark Mayes / mm-dev
 *
 *
 * @module PD/SOUND_DATA
 *
 * @description
 * ## Info about sound assets
 * - Used by `AssetPreloader` so it knows what to load
 */


import * as SOUND_IDS from "./SOUND_IDS.js";

export const SOUND_AR = [
  {
    id: SOUND_IDS.SFX_TWANG_1,
    file: "audio/twang-a6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_TWANG_2,
    file: "audio/twang-g6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_TWANG_3,
    file: "audio/twang-e6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_TWANG_4,
    file: "audio/twang-d6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_TWANG_5,
    file: "audio/twang-c6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_TWANG_6,
    file: "audio/twang-a5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_TWANG_7,
    file: "audio/twang-g5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_TWANG_8,
    file: "audio/twang-e5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_TWANG_9,
    file: "audio/twang-d5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_TWANG_10,
    file: "audio/twang-c5.mp3",
    volume: 0.1,
  },
  //
  {
    id: SOUND_IDS.SFX_POP_1,
    file: "audio/pop-a6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_POP_2,
    file: "audio/pop-g6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_POP_3,
    file: "audio/pop-e6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_POP_4,
    file: "audio/pop-d6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_POP_5,
    file: "audio/pop-c6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_POP_6,
    file: "audio/pop-a5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_POP_7,
    file: "audio/pop-g5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_POP_8,
    file: "audio/pop-e5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_POP_9,
    file: "audio/pop-d5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_POP_10,
    file: "audio/pop-c5.mp3",
    volume: 0.1,
  },
  //
  {
    id: SOUND_IDS.SFX_CLACK_1,
    file: "audio/clack-a6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CLACK_2,
    file: "audio/clack-g6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CLACK_3,
    file: "audio/clack-e6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CLACK_4,
    file: "audio/clack-d6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CLACK_5,
    file: "audio/clack-c6.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CLACK_6,
    file: "audio/clack-a5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CLACK_7,
    file: "audio/clack-g5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CLACK_8,
    file: "audio/clack-e5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CLACK_9,
    file: "audio/clack-d5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CLACK_10,
    file: "audio/clack-c5.mp3",
    volume: 0.1,
  },
  //
  {
    id: SOUND_IDS.SFX_CHOMP_1,
    file: "audio/chomp-a5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CHOMP_2,
    file: "audio/chomp-g5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CHOMP_3,
    file: "audio/chomp-e5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CHOMP_4,
    file: "audio/chomp-d5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CHOMP_5,
    file: "audio/chomp-c5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CHOMP_6,
    file: "audio/chomp-a4.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CHOMP_7,
    file: "audio/chomp-g4.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CHOMP_8,
    file: "audio/chomp-e4.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CHOMP_9,
    file: "audio/chomp-d4.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_CHOMP_10,
    file: "audio/chomp-c4.mp3",
    volume: 0.1,
  },
  //
  {
    id: SOUND_IDS.SFX_DROP_1,
    file: "audio/drop-a5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_DROP_2,
    file: "audio/drop-g5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_DROP_3,
    file: "audio/drop-e5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_DROP_4,
    file: "audio/drop-d5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_DROP_5,
    file: "audio/drop-c5.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_DROP_6,
    file: "audio/drop-a4.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_DROP_7,
    file: "audio/drop-g4.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_DROP_8,
    file: "audio/drop-e4.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_DROP_9,
    file: "audio/drop-d4.mp3",
    volume: 0.1,
  },
  {
    id: SOUND_IDS.SFX_DROP_10,
    file: "audio/drop-c4.mp3",
    volume: 0.1,
  },
  //
  {
    id: SOUND_IDS.SFX_DAMAGE,
    file: "audio/damage.mp3",
    volume: 0.05,
  },
];

export const ORDERED_TWANG_SFX_AR = [
  SOUND_IDS.SFX_TWANG_1,
  SOUND_IDS.SFX_TWANG_2,
  SOUND_IDS.SFX_TWANG_3,
  SOUND_IDS.SFX_TWANG_4,
  SOUND_IDS.SFX_TWANG_5,
  SOUND_IDS.SFX_TWANG_6,
  SOUND_IDS.SFX_TWANG_7,
  SOUND_IDS.SFX_TWANG_8,
  SOUND_IDS.SFX_TWANG_9,
  SOUND_IDS.SFX_TWANG_10,
];

export const ORDERED_POP_SFX_AR = [
  SOUND_IDS.SFX_POP_1,
  SOUND_IDS.SFX_POP_2,
  SOUND_IDS.SFX_POP_3,
  SOUND_IDS.SFX_POP_4,
  SOUND_IDS.SFX_POP_5,
  SOUND_IDS.SFX_POP_6,
  SOUND_IDS.SFX_POP_7,
  SOUND_IDS.SFX_POP_8,
  SOUND_IDS.SFX_POP_9,
  SOUND_IDS.SFX_POP_10,
];

export const ORDERED_DROP_SFX_AR = [
  SOUND_IDS.SFX_DROP_1,
  SOUND_IDS.SFX_DROP_2,
  SOUND_IDS.SFX_DROP_3,
  SOUND_IDS.SFX_DROP_4,
  SOUND_IDS.SFX_DROP_5,
  SOUND_IDS.SFX_DROP_6,
  SOUND_IDS.SFX_DROP_7,
  SOUND_IDS.SFX_DROP_8,
  SOUND_IDS.SFX_DROP_9,
  SOUND_IDS.SFX_DROP_10,
];

export const ORDERED_CHOMP_SFX_AR = [
  SOUND_IDS.SFX_CHOMP_1,
  SOUND_IDS.SFX_CHOMP_2,
  SOUND_IDS.SFX_CHOMP_3,
  SOUND_IDS.SFX_CHOMP_4,
  SOUND_IDS.SFX_CHOMP_5,
  SOUND_IDS.SFX_CHOMP_6,
  SOUND_IDS.SFX_CHOMP_7,
  SOUND_IDS.SFX_CHOMP_8,
  SOUND_IDS.SFX_CHOMP_9,
  SOUND_IDS.SFX_CHOMP_10,
];

export const ORDERED_CLACK_SFX_AR = [
  SOUND_IDS.SFX_CLACK_1,
  SOUND_IDS.SFX_CLACK_2,
  SOUND_IDS.SFX_CLACK_3,
  SOUND_IDS.SFX_CLACK_4,
  SOUND_IDS.SFX_CLACK_5,
  SOUND_IDS.SFX_CLACK_6,
  SOUND_IDS.SFX_CLACK_7,
  SOUND_IDS.SFX_CLACK_8,
  SOUND_IDS.SFX_CLACK_9,
  SOUND_IDS.SFX_CLACK_10,
];
